module.exports = __webpack_public_path__ + "img/102-b-06.prt.ff9c2dc6.jpg";